import { useAccountContext } from '@seek/hirer-graphql-react';

export const useGetAdvertiserId = () => {
  const { accountContext } = useAccountContext();

  const seekId = accountContext?.currentAdvertiser?.seekId;
  return seekId || '';
};
